import React, { useCallback, useMemo, useRef, useState } from "react"
import { CursorContext } from "./CursorContext"
import { CursorRenderer } from "./CursorRenderer"
import { CURSORS } from "./cursors"

export default function CursorProvider({ children }) {
  // stack of { id, config }, top of array = active zone
  const stackRef = useRef([])
  const [active, setActive] = useState(null) // config object, only changes on zone switch

  const recompute = useCallback(() => {
    const top = stackRef.current[stackRef.current.length - 1]
    setActive(top ? top.config : null)
  }, [])

  const push = useCallback((id, config) => {
    const stack = stackRef.current
    const existingIdx = stack.findIndex((z) => z.id === id)
    if (existingIdx !== -1) stack.splice(existingIdx, 1) // move to top w/ fresh config
    stack.push({ id, config })
    recompute()
  }, [recompute])

  const pop = useCallback((id) => {
    const stack = stackRef.current
    const idx = stack.findIndex((z) => z.id === id)
    if (idx !== -1) stack.splice(idx, 1)
    recompute()
  }, [recompute])

  const ctxValue = useMemo(() => ({ push, pop }), [push, pop])

  return (
    <CursorContext.Provider value={ctxValue}>
      {children}
      <CursorRenderer config={active || CURSORS.default} />
    </CursorContext.Provider>
  )
}